// Placeholders LlmService actually substitutes at runtime, per prompt type
// (mirrors the str_replace calls in podsy-be/app/Services/Llm/LlmService.php)
export const PROMPT_TAGS = {
    InsightImage: [
        '{key_takeaway_title}',
        '{key_takeaway_insight}',
        '{key_takeaway_quote}',
        '{episode_title}',
        '{episode_description}',
        '{podcastclub_title}',
        '{podcastclub_description}',
    ],
    insights_with_processing_details: [
        '{INPUT_TEXT}',
        '{PRACTICE_SKILLS}',
        '{INPUT_TITLE}',
        '{INPUT_DESCRIPTION}',
        '{INPUT_SKILLS}',
    ],
    discussion_prompts: [
        '{EPISODE_DESCRIPTION}',
        '{EPISODE_TRANSCRIPT}',
        '{EPISODE_INSIGHTS}',
        '{EXISTING_DISCUSSIONS}',
        '{SIMILARITY_INSTRUCTION}',
    ],
};
